/**
 * Combines class names into a single string.
 * @param inputs - The class names to combine.
 */
export function cn(
  ...inputs: Array<string | undefined | null | false>
): string {
  return inputs.join(" ");
}
